import React, { useState, useEffect, useCallback } from 'react';

import { downloadFile, extractFileNameFromHeaders } from '../../../../util/DownloadUtil';

import { retrievePageTrackerStudyReport, downloadPageTrackerStudyReport } from '../../../../services/ReportService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import './PageTracking.css';

export const PageTracking = ({ context, setSpinnerText, showToaster, downloadEnabled }) => {
  const [results, setResults] = useState([]);

  const generateReport = useCallback(async () => {
    setSpinnerText('Generating Report');
    const [data, error] = await retrievePageTrackerStudyReport(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        setResults(
          data.pageTrackerPerStudyVOS.map((vo) => ({
            studyName: vo.studyName,
            site: vo.site,
            usedPages: vo.usedPages,
            unusedPages: vo.unusedPages,
            totalPages: vo.totalPages,
          }))
        );
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster]);

  useEffect(() => {
    generateReport();
  }, [generateReport]);

  const handleDownloadExcelClick = async () => {
    setSpinnerText('Downloading Page Tracker per Study Report');

    const [data, headers, error] = await downloadPageTrackerStudyReport(context.username);
    if (data) {
      const name = extractFileNameFromHeaders(headers);
      downloadFile(data, name);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }

    setSpinnerText(undefined);
  };

  return (
    <section className="page-tracking">
      <div className="page-tracking-table">
        <h1 className="page-tracking-table-heading">Page Tracker per Study</h1>
        <Table
          tableData={results}
          tableTitle=" "
          maxRowCount={8}
          hiddenColumns={[]}
          searchEnabled
          filterEnabled
          horizontalScroll
        />
      </div>
      {downloadEnabled && (
        <div className="page-tracking-table-buttons">
          <SaveButton
            title="Download Excel"
            onClick={handleDownloadExcelClick}
            color="#077187"
            border="1px solid #077187"
          />
        </div>
      )}
    </section>
  );
};
